import $ from "jquery";
import translate from "translate";
import ga from "analytics";
import notification from "notification";

function showError(text) {
  $('.ajax.notification.error').remove();
  notification.top.create({
    "className": "ajax error",
    "html": text
  });
}

export default {
  show: showError,
  handler: function (event) {
    if (event.status === 500) {
      showError(translate('server-error'));
    } else if (event.status === 404) {
      showError(translate('no-connection'));
    }
    ga.trackError({
      'exDescription': "Response code was " + event.status
    });
  }
};



// WEBPACK FOOTER //
// ./web/js/error.js